<template>
  <v-list nav dense class="navbar-list">
    <navbar-list-item v-for="(route, i) in routes" :key="i" :route="route" :level="1" v-if="route.show" />
  </v-list>
</template>

<script>
import NavbarListItem from "./NavbarListItem";
export default {
  name: "NavBar",
  components: { NavbarListItem },
  data() {
    return {};
  },
  computed: {
    /*
      returns all routes
      if called outside of component it will miss some params or queries, but names & titles are currect
    */
    allRoutes() {
      return [
        {
          title: "خانه",
          to: {
            name: "Home",
          },
          perm: "home_page"
        },
        {
          title: "کسب و کار ها",
          to: {
            name: "CompaniesList",
          },
          perm: "companies"
        },
        {
          title: "اپراتور ها",
          to: {
            name: "AdminOperators",
          },
          perm: "operators" 
        },
        {
          title: "کاربران",
          to: {
            name: "UsersList",
          },
          perm: "users"
        },
        {
          title: "کد های معرف",
          to: {
            name: "ReferralCodes",
          },
          perm: "referral_codes"
        },
        {
          title: "تراکنش ها",
          to: {
            name: "FactorsList",
          },
          perm: "factors"
        },
        {
          title: "کد تخفیف",
          perm: "discounts",
          children: [
            {
              title: "تعریف کد تخفیف",
              to: {
                name: "DiscountCodeForm",
              },
            },
            {
              title: "لیست کد های تخفیف",
              to: {
                name: "DiscountCodesList",
              },
            },
            {
              title: "کد های تخفیف استفاده شده",
              to: {
                name: "usedDiscountCodeList",
              },
            },
          ],
        },
        {
          title: "افزونه و پکیج ها",
          to: {
            name: "Packages",
          },
          perm: "extensions" 
        },
        {
          title: "حسابداری ابری",
          to: {
            name: "CloudAccounting",
          },
          perm: "cloud_accounting"
        },
        {
          title: "مدیریت کیف پول کاربران",
          to: {
            name: "WalletUsers",
          },
          perm: "can_manage_withdrawals"
        },
        {
          title: "مدیریت برداشت ها",
          to: {
            name: "WithdrawalManagement",
          },
          perm: "can_manage_withdrawals"
        },
        {
          title: "ویرایش بسته و ما‌به‌تفاوت",
          to: {
            name: "ExtensionAdjustment",
          },
          perm: "can_manage_withdrawals"
        },
        {
          title: "سابقه فعالیت‌های اپراتور ها",
          perm: "admin_actions_logs",
          to: {
            name: "adminActionLog",
          },
        },
        {
          title: "گزارش ماهانه",
          perm: "factors",
          to: {
            name: "MonthlySalesReport",
          },
        },
        // { title: "مدیریت درگاه‌های پرداخت", to: { name: "PaymentGatewayManagement" } },
        { title: "گزارش ارسال‌های مودیان", perm: "moadian_submissions", to: { name: "MoadianSubmissions" } },
        // {
        //   title: "CRM",
        //   children: [
        //     { title: "فضای کاری CRM", to: { name: "CrmHome" } },
        //     { title: "سرنخ‌ها", to: { name: "CrmLeads" } },
        //     { title: "پیگیری‌ها", to: { name: "CrmFollowUps" } },
        //     { title: "تماس‌ها", to: { name: "CrmOperatorContacts" } },
        //     { title: "داشبورد CRM", to: { name: "CrmDashboard" }, manager: true },
        //     { title: "اپراتورهای CRM", to: { name: "CrmOperators" }, manager: true },
        //     { title: "گزارش روزانه CRM", to: { name: "CrmDailyReport" }, manager: true },
        //     { title: "گزارش تماس‌های CRM", to: { name: "CrmContactsReport" }, manager: true },
        //   ],
        // },
      ];
    },
    routes() {
      const checkVisibility = (route) => {
        let visible = false;
        if (route.perm) {
          visible = !!this.user?.permissions?.[route.perm];
        } 
        else if (route.children) {
          visible = route.children.some(checkVisibility);
        } 
        else {
          visible = true;
        }

        route.show = visible;
        return visible;
      };

      return this.allRoutes.map(route => {
        checkVisibility(route);
        return route;
      });
    },
    username() {
      if (this.user.username.includes("manager")) return "manager";
      return this.user.username;
    },
  },
};
</script>

<style lang="scss">
.navbar-list {
  .list-item-title {
    // color: white;
    font-weight: 300 !important;
    font-size: 0.9rem !important;
  }
  .v-icon {
    // color: rgba(white, 0.8) !important;
  }
}
</style>
